// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { JwtHelperService } from '@auth0/angular-jwt';
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
import { ManageVendorAccountsResultDto } from '../_models/manage-vendor-accounts-result-dto';
import { VendorAccountHistoryResultDto } from '../_models/vendor-account-history-result-dto';
import { StatusMessageResultDto } from '../../_models/status-message-result-dto';
import { VendorAccountEditorResultDto } from '../_models/vendor-account-editor-result-dto';
import { VendorNotesResultDto } from '../_models/vendor-notes-result-dto';
import { BaseVendorAccountResultDto } from '../_models/base-vendor-account-result-dto';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class VendorAccountEditService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
        this.jwtHelper = new JwtHelperService();
    }
    getVendorAccountDetail(baseParams) {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}vendor/account/manage${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(ManageVendorAccountsResultDto, response)));
    }
    getVendorAccountHistory(baseParams) {
        const url = `${URLConstants.ccVendorAccountBaseApiUrl}/history${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(VendorAccountHistoryResultDto, response)));
    }
    getVendorAccountNotes(baseParams) {
        const url = `${URLConstants.ccVendorAccountBaseApiUrl}/notes${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(VendorNotesResultDto, response)));
    }
    saveVendorAccountNotes(baseParams) {
        return this.httpClient
            .post(`${URLConstants.ccVendorAccountBaseApiUrl}/notes`, classToPlain(baseParams))
            .pipe(map((responseData) => responseData));
    }
    getVendorAccountEditor(baseParams) {
        const url = `${URLConstants.ccVendorAccountBaseApiUrl}/editor${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(VendorAccountEditorResultDto, response)));
    }
    saveVendorAccount(baseParams) {
        return this.httpClient
            .post(URLConstants.ccVendorAccountBaseApiUrl, classToPlain(baseParams))
            .pipe(map((responseData) => plainToClass(StatusMessageResultDto, responseData)));
    }
    getVendorAccountEFTForm(baseParams) {
        const url = `${URLConstants.ccVendorAccountBaseApiUrl}/eftform${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((responseData) => new Blob([responseData])));
    }
    getVendorAccount(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}vendor/account/manage${baseParam.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(ManageVendorAccountsResultDto, response)));
    }
    getVendorAccountList(baseParam) {
        const url = `${URLConstants.ccVendorAccountBaseApiUrl}${baseParam.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData) => plainToClass(BaseVendorAccountResultDto, responseData)));
    }
}
VendorAccountEditService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VendorAccountEditService_Factory() { return new VendorAccountEditService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: VendorAccountEditService, providedIn: "root" });
